module.exports = __webpack_public_path__ + "static/media/imzaPosLogo.9c662807.png";